import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from "@material-ui/core";
import React from 'react'


const Technologies = ({text, progress}, index) => {
    const classes = useStyles();
    const list = [
        {
            text: "HTML",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={100} />
        },
        {
            text: "CSS",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={100} />
    
        },
        {
            text: "Git",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={70} />
    
        },
        {
            text: "SASS",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={60} />
    
        },
        {
            text: "JavaScript",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={60} />
    
        },
        {
            text: "Bootstrap",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={60} />
    
        },
        {
            text: "Express",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={40} />
    
        },
        {
            text: "Node.js",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={10} />
    
        },
       
        
        {
            text: "Vue.js",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={30} />
    
        },
        {
            text: "Flutter",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={30} />
    
        },
        {
            text: "MVC",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={30} />
    
        },
        {
            text: "MongoDB",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={15} />
    
        },
        {
            text: "React",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={10} />
    
        },
        
        
        
    ]
    const design = [
        {
            text: "Illustrator",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={90} />
    
        },
        {
            text: "Photoshop",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={80} />
        },
        {
            text: "Abode XD",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={80} />
    
        },
        {
            text: "Figma",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={80} />
    
        },
        {
            text: "Indesign",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={70} />
    
        },
        {
            text: "Lightroom",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={50} />
    
        },
        {
            text: "Fotografía",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={50} />
    
        },
        {
            text: "After Effects",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={40} />
    
        },
        {
            text: "Premiere",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={40} />
    
        },
        {
            text: "RRSS",
            progress:  <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}} variant="determinate" value={40} />
    
        },
      
        
    ]
    return (
        <div data-aos="fade-up" className={classes.container}>
            <ul>
                <h2 className={classes.titleskills}>Lenguages</h2>
                {list.map(index => (
                <li key={index.id} className={classes.listcontent}>
                    <div>{index.text}</div>
                    <div className={classes.progress}>{index.progress}</div>
                </li>
                ))}
            </ul>
            <ul>
            <h2 className={classes.titleskills}>Design</h2>

                {design.map(index => (
                <li key={index.id} className={classes.listcontent}>
                    <div>{index.text}</div>
                    <div className={classes.progress}>{index.progress}</div>
                </li>
                ))}
            </ul>

        </div>
    )
}

const useStyles = makeStyles((theme)=>({
    container:{
        margin: theme.spacing(5, 12),
        display:"flex",
        gap: "120px",
        [theme.breakpoints.down('sm')]:{
            flexDirection:"column",
             gap: "20px",
              margin: theme.spacing(5, 3),
           
        }
    },
    listcontent : {
        display:"flex",
        alignItems: "center",
        gap: "60px",
        fontSize:"1rem",
        fontWeight:"bold",
        lineHeight:"35px",
        justifyContent: "space-between",
        padding:0,
        [theme.breakpoints.down('sm')]:{
            flexDirection:"row",
            gap: "0px",
            width: "80vw",
            justifyContent: "space-between",
           
        }
    },
    progress:{
        width:"25vw",
        marginLeft: "0px",
        [theme.breakpoints.down('sm')]:{
           width:"50vw",
        }
    },
    colorPrimary: {
        backgroundColor: "#efe0ef",
      },
      barColorPrimary: {
        backgroundColor: "#8d6189",
      },
      titleskills:{
          marginBottom:"10px",
          fontWeight:"900",
          fontSize:"1.3rem",
        
      }
  }))
  
export default Technologies
